<template lang="pug">
.do-task(v-if="show" @touchmove.prevent)
  img(v-show="false" src="https://m.hellobike.com/resource/gallery/350/AJRHNzYWDG.png?x-oss-process=image/quality,q_80")
  transition(name="dialog")
    .task-dialog(v-if="showDialog")
      .dialogTitle()
        img.dialogImg(
          src="https://m.hellobike.com/resource/gallery/350/24oSIAzP_Group%2091.png?x-oss-process=image/quality,q_80"
        )
      .dialogContent(:class="{'animate__animated animate__flipInY': showDialog}")
        .taskName {{ taskInfo.taskName }}
        .taskMoney()
          span 再得
          span.money {{ taskInfo.offerWorth }}
          span 个奖励金
        .taskBtn(
          :class="{ 'task-done': taskInfo.taskStatus === TASK_STATUS.FINISHED }"
          @click="handleBtnClick"
        ) {{ taskInfo.popupBtnName }}
      .closeBtn(@click="handlePopupclose")
</template>

<script>
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import eventBus from '@/const/eventBus';
import { debounce } from '@/utils';
import 'animate.css';
import { TASK_STATUS_V2 } from '@/const/task';
import SPM from '../common/spm';
import { handleTaskBtnClick } from '../common/task';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    taskInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // 弹窗显示
      showDialog: false,
      // 跳转定时器
      jumpTimer: null,
      // 任务状态
      TASK_STATUS: TASK_STATUS_V2,
    };
  },
  watch: {
    show(value) {
      if (value) {
        setTimeout(() => {
          this.showDialog = true;
        }, 20);

        // 任务弹窗曝光
        SPM.moduleExpose({
          moduleId: 'Welfare_taskpop',
          contentId: 'Welfare_taskpop',
          businessInfo: {
            task_id: this.taskInfo.taskCode,
          },
        });
      }
    },
  },
  mounted() {
    this.clearTimeout();
  },
  beforeDestroy() {
    this.jumpTimer = null;
  },
  methods: {
    // 任务跳转处理
    handleBtnClick: debounce(async function exec() {
      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'growexchange',
        categoryId: 'platform',
        businessInfo: {},
      });

      const options = {
        scene: 'task_popup',
      };
      const { closePopup, info } = await handleTaskBtnClick.call(
        this,
        this.taskInfo,
        options,
      );
      this.showDialog = !closePopup;
      this.$emit('update:show', !closePopup);
      this.$emit('btnClick', { closePopup, info });
    }, 300),
    // 弹窗关闭
    handlePopupclose() {
      this.showDialog = false;
      this.$emit('update:show', false);
      SPM.clickButton({
        buttonName: 'Welfare_taskpop_close',
        businessInfo: {
          task_id: this.taskInfo.taskCode,
        },
      });
      // 刷新任务列表
      eventBus.$emit('refreshTaskList');
    },
    // 清除倒计时
    clearTimeout() {
      const clearTimeout = () => {
        if (this.jumpTimer) {
          clearTimeout(this.jumpTimer);
        }
      };
      document.addEventListener('visibilitychange', () => {
        if (document.hidden || document.webkitHidden) {
          clearTimeout();
        }
      });
      window.addEventListener('pagehide', () => {
        clearTimeout();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.do-task {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  padding-top: 2.32rem;
  padding-left: 0.39rem;
  z-index: 100;

  .task-dialog {
    position: relative;
    width: 2.97rem;
    height: 2.21rem;

    .dialogTitle {
      width: 100%;
      height: 0.41rem;
      text-align: center;

      .dialogImg {
        display: inline-block;
        width: 1.44rem;
        height: 0.33rem;
      }
    }

    .dialogContent {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      height: 1.69rem;
      border-radius: 0.12rem;
      background-image: url(https://m.hellobike.com/resource/gallery/350/AJRHNzYWDG.png?x-oss-process=image/quality,q_80);
      background-position: 0 0;
      background-repeat: no-repeat;
      background-size: contain;

      .taskName {
        font-size: 0.18rem;
        color: #242729;
        font-weight: 600;
        padding-top: 0.32rem;
        text-align: center;
        box-sizing: border-box;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
      }

      .taskMoney {
        text-align: center;
        font-size: 0.14rem;
        color: #5a6066;
        margin-top: 0.12rem;

        .money {
          color: #ff710c;
        }
      }

      .taskBtn {
        margin-top: 0.24rem;
        width: 2.57rem;
        height: 0.4rem;
        background-image: linear-gradient(136.83deg, #ff8e67 9.45%, #ff5103 92.49%);
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        color: #fff;
        border-radius: 0.08rem;
        font-size: 0.14rem;

        &.task-done {
          background-image: none;
          background-color: #ffd764;
          color: #643b00;
        }
      }
    }

    .dialogContent.animate__flipInY {
      --animate-duration: 1s;
    }

    .closeBtn {
      position: absolute;
      transform: translateX(-50%);
      left: 50%;
      top: 2.79rem;
      width: 0.36rem;
      height: 0.36rem;
      background-image: url(https://m.hellobike.com/resource/gallery/350/bE_IeZ_a_Group%2092.png?x-oss-process=image/quality,q_80);
      background-position: 0 0;
      background-repeat: no-repeat;
      background-size: contain;
    }
  }
}
</style>
